import { useAdminStore } from '@/stores/adminStore';

function tokenBadge(status: string) {
  const styles: Record<string, string> = {
    active: 'bg-accent-green/15 text-accent-green',
    expiring_soon: 'bg-accent-orange/15 text-accent-orange',
    expired: 'bg-accent-red/15 text-accent-red',
  };
  const labels: Record<string, string> = {
    active: 'Activo',
    expiring_soon: 'Por expirar',
    expired: 'Expirado',
  };
  return (
    <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${styles[status] || ''}`}>
      {labels[status] || status}
    </span>
  );
}

function roleBadge(role: string) {
  const isAdmin = role === 'admin';
  return (
    <span
      className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${
        isAdmin ? 'bg-accent-purple/15 text-accent-purple' : 'bg-bg-tertiary text-text-muted'
      }`}
    >
      {role}
    </span>
  );
}

function timeAgo(minutes: number): string {
  if (minutes < 1) return 'ahora';
  if (minutes < 60) return `${Math.round(minutes)}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;
  return `${Math.floor(hours / 24)}d`;
}

export default function ActiveUsersTab() {
  const users = useAdminStore((s) => s.activeUsers);

  if (users.length === 0) {
    return (
      <div className="text-center text-text-muted text-sm py-12">
        Sin datos de usuarios activos
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {users.map((u) => (
        <div
          key={u.user_id}
          className="flex items-center gap-3 px-3 py-2.5 bg-bg-tertiary/50 border border-border-subtle rounded-lg"
        >
          {/* Online dot */}
          <div
            className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${
              u.is_online
                ? 'bg-accent-green shadow-[0_0_6px_var(--accent-green)]'
                : 'bg-text-subtle'
            }`}
          />

          {/* Info */}
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <span className="text-sm font-semibold text-text-primary truncate">
                {u.username}
              </span>
              {roleBadge(u.role)}
            </div>
            <div className="text-[11px] text-text-muted mt-0.5">
              {u.is_online ? 'En linea' : `Hace ${timeAgo(u.minutes_ago)}`}
            </div>
          </div>

          {/* Token status */}
          <div className="flex-shrink-0">
            {tokenBadge(u.token_status)}
          </div>
        </div>
      ))}
    </div>
  );
}
